import React,{useState} from 'react';
import './Resturant.css'
import "bootstrap/dist/css/bootstrap.min.css";
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'bootstrap-v4-rtl/dist/css/bootstrap-rtl.min.css';
// eslint-disable-next-line
import i18n from "../../i18n";
import { useTranslation } from 'react-i18next';
import NavBar from '../NavBar/NavBar';
import Cookies from 'js-cookie';
import ProjectDetails from '../ProjectDetails/ProjectDetails';
import ProjectDetailsCard from '../ProjectDetailsCard/ProjectDetailsCard';
import Video from '../Video/Video';
import Footer from '../Footer/Footer'
import imageRest1 from '../../images/1rest.JPG';
import imageRest2 from '../../images/2rest.JPG';
import imageRest3 from '../../images/3rest.JPG';
import imageRest4 from '../../images/4rest.JPG';
import Security from '../../images/project/Security_and_privacy.jpg';
import General from '../../images/project/General_Features.jpg';
import Ease from '../../images/project/Ease_of_use.jpg';


function Resturant() {
  const { t, i18n } = useTranslation();
  let Cookieslan = Cookies.get('i18next');
  if(Cookieslan === 'en'){
    Cookieslan = 'ltr';
  }if(Cookieslan === 'ar'){
    Cookieslan = 'rtl';
  }
  //change dir and lang 
  const [ddir, setDdir] = useState(Cookieslan);
  const className =  ddir ;
  return (
    <div className={className}>
      <NavBar onDirChange={setDdir} />
      <div>
        <ProjectDetails heading="Resturant"
          image1={imageRest1}
          image2={imageRest2}
          image3={imageRest3}
          image4={imageRest4}
          Category={t('Program')}
          compatibility={t('All_devices')}
          date="01 March, 2006"
          href='https://jsource.sy/'
          Url='www.example.com'
          descriptionH={t('The_Resturant_program')}
          description={t('An_easy_and_fast')} />
      </div>

      <section id="Properties" class="Properties section-bg">
        <div class="container" data-aos="fade-up">

          <div class="section-title">
            <h2>{t('Properties')}</h2>
            <p>{t('These_are_the_most_important')}</p>
          </div>

          <div class="row">
            <ProjectDetailsCard image={Security} headding={t('Security_and_privacy')} containar={t('The_network_system_depends')} />
            <ProjectDetailsCard image={General} headding={t('General_Features')} containar={<><p>{t('Unlimited_number_of_tables')}</p><p>{t('Support_all_printers')}</p><p>{t('Automated_backup')}</p><p>{t('Great_flexibility_in_searching')}</p></>} />
            <ProjectDetailsCard image={Ease} headding={t('Ease_of_use')} containar={t('The_program_was_developed')} />
          </div>
        </div>
      </section>
      <section id="about-video" class="about-video">
        <div className="container" data-aos="fade-up">

          <div className="row">
            <Video image={imageRest1} href="https://www.youtube.com/watch?v=jDDaplaOz7Q" />
          </div>

        </div>
      </section>
      <Footer/>
    </div>

  );
}

export default Resturant;
